import axios from "axios";
import {
  FETCH_BREEDS,
  CREATE_BREED,
  UPDATE_BREED,
  DELETE_BREEDS,
  FETCH_ANIMALS,
  FETCH_BREEDS_BY_ANIMAL,
  FETCH_BREEDS_CATEGORY,
  FETCH_BREED_INFO,
  FETCH_UPDATED_BREED_BY_ID,
  interceptor
} from ".";
// import { BASE_URL } from "../utils/helper";

import store from "../store";
interceptor(axios, store);

export function createBreedType(breedType) {
  return {
    type: CREATE_BREED,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/breed/`, breedType, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateBreedType(breedType) {
  return {
    type: UPDATE_BREED,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/breed/${breedType.id}`, breedType, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deleteBreedType(selected) {
  const ids = { ids: selected };
  return {
    type: DELETE_BREEDS,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/breed/delete/`, ids, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchBreedTypes() {
  return {
    type: FETCH_BREEDS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/breed/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchAnimalTypes() {
  return {
    type: FETCH_ANIMALS,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/pet/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchBreedTypesByAnimal(animal) {
  return {
    type: FETCH_BREEDS_BY_ANIMAL,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/breed/getBreedsByAnimal/${animal}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}


export function fetchBreedInfo(id){
  return {
    type: FETCH_BREED_INFO,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/breed/getBreedInfo/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}


export function fetchUpdatedBreedTypeById(id){

  return {
    type: FETCH_UPDATED_BREED_BY_ID,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/breed/getUpdatedBreedTypeById/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}